import { AppSportsBookState } from 'src/domains/sportsbook/state/AppSportsBook.state';
import React, { useState } from 'react';
import { QuickLinkTrayItem } from './QuickLinkTrayItem';
import { QuickLinkTrayWrapper } from './QuickLinkTray.style';
import { observer } from 'src/utils/mobx-react';
import { QuickLinkTrayState } from './QuickLinkTray.state';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

const QuickLinkTray = observer('QuickLinkTray', () => {
    const common = useCommon();
    const appSportsBookState = AppSportsBookState.get(common);
    const [quickLinkTrayState] = useState(() => new QuickLinkTrayState(appSportsBookState.models));

    const configState = ConfigComponents.get(common).config;
    const { sortedLinks } = quickLinkTrayState;

    if (sortedLinks.length > 0) {
        return (
            <QuickLinkTrayWrapper
                data-test='quick-link-tray'
                variant={configState.componentVariants.quickTrayLinkVariant}
            >
                {sortedLinks.map((link) => (
                    <QuickLinkTrayItem
                        key={link.id}
                        link={link}
                    />
                ))}
            </QuickLinkTrayWrapper>
        );
    }
    return null;
});

export const QuickLinkTrayContainer = observer('QuickLinkTrayContainer', () => {
    const common = useCommon();

    const breakpointsState = BreakpointsState.get(common);
    const configState = ConfigComponents.get(common).config;
    const { quickTrayLinkVariant } = configState.componentVariants;

    const isBiggerOrEq = breakpointsState.tablet.isBiggerOrEq;

    if (isBiggerOrEq === false || quickTrayLinkVariant === DefaultComponentVariantType.SECONDARY) {
        return <QuickLinkTray />;
    }

    return null;
});
